import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";

export type IntegrationsServiceApiType = { syncIntegrations(): Promise<void> };

export const createIntegrationsService = (fetchService: IFetchService): IntegrationsServiceApiType => ({
    syncIntegrations: createCancelable((cancellation: AbortSignal) => {
        return fetchService.get(`/sales-api/crm-integration/sync`, null, { cancellation });
    }),
});
